export const getLocalStorage = () => localStorage;

/**
 * Sets connector in localStorage
 * @param {String} extId - connector external id
 * @param {String} name - connector name
 * @param {String} type - connector type
 * @returns {void}
 */
export const setToLocal = ({ extId = '', name = '', type = '' }) => {
    localStorage.setItem(
        'connector',
        JSON.stringify({
            extId,
            name,
            type,
        })
    );
};
